import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { rem } from 'polished'
import Brandy from '../../Brandy'
import * as LinkButtonStyled from '../../LinkButton/LinkButton.styles'

export const Animator = styled.div`
  margin-left: auto;
  margin-right: auto;

  > * {
    transition: all 0.3s ease-in;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    &:hover {
      cursor: pointer;

      > * {
        transform: translateY(-8px);
        box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.primary.base.hex},
          0 8px 10px ${({ theme }) => theme.colors.light.darker.hex};
        border-color: ${({ theme }) => theme.colors.primary.dark.hex};

        button {
          background-color: ${({ theme }) => theme.colors.primary.dark.hex};
        }
      }
    }
  }
`

export const Disclaimer = styled(Brandy)`
  margin-top: 0;
  margin: ${({ theme }) => theme.spacing.sm};
  padding-left: ${({ theme }) => theme.spacing.min};
  padding-right: ${({ theme }) => theme.spacing.min};
`

// TODO: This needs to be refactored to new style approach
// Overwriting the LinkButton this way to display none the icon is a temporary
// adjustment to get away from flex-box nonesense when the button is 100% width
export const PackageCardStyles = ({ theme }) => {
  const PackageCard = theme?.components?.PackageCard
  const Price = theme?.components?.Price

  const alignItems = {
    left: 'flex-start',
    center: 'center',
    default: 'flex-start',
  }

  return css`
    flex-direction: column;
    display: flex;
    gap: 16px;
    width: 100%;
    height: 100%;
    max-width: 320px;
    padding: 16px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    isolation: isolate;

    // THEME LEVEL STYLES
    align-items: ${alignItems[PackageCard?.alignment] || alignItems.default};

    text-align: ${PackageCard?.alignment};
    background-color: ${PackageCard?.backgroundColor ||
    theme?.colors?.light?.lighter?.hex};
    border-radius: ${PackageCard?.radius || '0'};
    box-shadow: ${PackageCard?.shadow || '0 4px 8px #d8dcdf'};
    border: ${(PackageCard?.stroke.width &&
      `${PackageCard?.stroke?.width} ${PackageCard?.stroke?.style} ${PackageCard?.stroke?.color}`) ||
    'none'};

    border-top: ${`solid ${PackageCard?.stroke?.width || theme.spacing.xxs} ${
      PackageCard?.stroke?.color || theme.colors.primary.base.hex
    }`};

    .leshen-price-wrapper {
      .leshen-price-amount-wrapper {
        margin-left: ${PackageCard?.alignment === 'left' // eslint-disable-line
          ? '0'
          : 'auto'};
        margin-right: ${PackageCard?.alignment === 'left' // eslint-disable-line
          ? ''
          : 'auto'};
        justify-content: ${PackageCard?.alignment === 'left' // eslint-disable-line
          ? 'flex-start'
          : 'center'};
        align-items: ${Price?.dollarSign?.position === 'top' // eslint-disable-line
          ? 'flex-start'
          : Price?.dollarSign?.position === 'bottom'
          ? 'flex-end'
          : 'center'};
      }
    }

    .title,
    .description {
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 0;
    }

    ${LinkButtonStyled.LinkButton} {
      align-self: stretch;
      margin: ${`${theme.spacing.lg} 0 0`};

      button {
        width: 100%;
        justify-content: center;
      }

      &:first-of-type {
        margin-top: auto;
      }

      & + a {
        margin-top: 8px;
      }
    }

    .price-old {
      margin: 0;
    }

    .modal {
      // THEME LEVEL STYLES
      width: ${PackageCard?.alignment === 'left' ? '100%' : 'auto'};

      > span {
        margin-bottom: 0;
        line-height: ${rem(theme.fonts.body.xs.lineHeight)};
        color: ${`${PackageCard?.color || 'black'} !important`};

        p {
          font-size: ${rem(theme.fonts.body.xs.size)};
          margin-bottom: 0;
          margin-top: 0;
        }
      }
    }

    .details {
      margin: ${`0 0 ${theme.spacing.sm}`};
      padding: ${`${theme.spacing.sm} 0`};
      background-color: ${theme.colors.light.base.hex};
      display: flex;
      justify-content: space-around;
      align-items: stretch;
      font-size: 12px;
      line-height: 14px;
      width: 100%;

      > span {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        flex: 1;
        padding: ${`${theme.spacing.min}  ${theme.spacing.xs}`};

        &::after {
          display: block;
          position: absolute;
          right: 0;
          top: 0;
          content: '';
          width: 1px;
          height: 100%;
          background-color: ${theme.colors.dark.lightest.hex};
        }

        &:last-of-type::after {
          display: none;
        }
      }
    }

    .spacer {
      flex: 1;
    }

    .before {
      color: ${`${PackageCard?.color || 'black'} !important`};
    }

    .leshen-price-disclaimers-wrapper {
      padding-left: 0;
      padding-right: 0;
      margin-left: 0;

      * {
        color: ${`${PackageCard?.color || 'black'} !important`};
      }
    }

    .leshen-link-button {
      border-radius: ${theme.radius};
    }

    .leshen-link {
      display: block;
      width: 100%;
    }

    .price {
      &__wrapper {
        display: inline-block;
      }

      .leshen-price-currency {
        display: inline-block;
        line-height: 1em;

        // THEME LEVEL STYLES
        vertical-align: ${Price?.dollarSign?.position === // eslint-disable-line
        'bottom'
          ? 'bottom'
          : Price?.dollarSign?.position === 'center'
          ? 'baseline'
          : 'top'};
      }

      .leshen-price-change {
        line-height: 1em;
      }

      .leshen-price-duration {
        display: flex;

        // THEME LEVEL STYLES
        color: ${`${PackageCard?.color || 'black'} !important`};
      }
    }

    .main-content {
      width: 100%;
      margin-top: auto;
      display: flex;
      gap: 8px;
      flex-direction: column;
      text-align: ${PackageCard?.alignment};
      color: ${`${PackageCard?.color || 'black'} !important`};

      .leshen-phone-cta svg {
        margin: 0;
      }

      > {
        margin-bottom: 8px;
      }
    }
  `
}
export const PackageCard = styled.div(PackageCardStyles)

export const CustomText = styled.h4(
  ({ theme }) => css`
    font-family: ${theme?.fonts?.body?.family};
    font-weight: ${theme?.components?.Price?.dollar?.weight || 'bold'};
    font-size: ${theme?.components?.Price?.dollarSign?.size
      ? theme?.components?.Price?.dollarSign?.size
      : rem(theme.fonts.headings.lg?.size[1])};
    line-height: 1;
    margin-bottom: 0;
  `
)

export const CustomTextContainer = styled.span(({ theme, inPackageCard }) => {
  let color = 'inherit'

  if (theme?.components?.Price?.color) {
    color = theme?.components?.Price?.color
  } else if (inPackageCard) {
    color = theme?.components?.PackageCard?.color || 'black'
  }

  return css`
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${CustomText}, .leshen-brandy {
      color: ${color} !important;
    }

    .leshen-brandy:last-child {
      margin-bottom: 0;
    }
  `
})
